import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'fern',
      d: 'M-1,-8h1v0.5h-1zM-0.5,-7.5h1v0.5h-1zM-0.5,-7h1.5v2h-1.5zM1.5,-6.5h1v1h-1zM1.5,-5.5h1.5v0.5h-1.5zM-1,-5h1.5v0.5h-1.5zM1.5,-5h1v0.5h-1zM-1.5,-4.5h1.5v1.5h-1.5zM1,-4.5h0.5v0.5h-0.5zM2,-4.5h0.5v0.5h-0.5zM0.5,-4h1.5v1h-1.5zM-1.5,-3h0.5v0.5h-0.5zM-0.5,-3h0.5v0.5h-0.5zM1,-3h1v1h-1zM-1,-2.5h1.5v1h-1.5zM1,-2h1.5v1h-1.5zM-1,-1.5h0.5v0.5h-0.5zM0,-1.5h0.5v1h-0.5zM1.5,-1h1v0.5h-1zM-0.5,-0.5h1v0.5h-1zM1.5,-0.5h0.5v0.5h-0.5zM-0.5,0h2v0.5h-2zM-1,0.5h3v0.5h-3z',
    },
    {
      paint: 'moss',
      d: 'M1.5,-4.5h0.5v0.5h-0.5zM-1,-3h0.5v0.5h-0.5zM-0.5,-1.5h0.5v1h-0.5zM1,-1h0.5v1h-0.5z',
    },
  ],
  pixels: 87,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
